import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  CustomAlert,
  CustomButton,
  MultipleSelect,
} from "../../shared/uiComponents";

import { DispatchProperties, useSelector } from "../../redux/store";
import { SelectChangeEvent } from "@mui/material";
import {
  assignClinicalSupervisors,
  getBCBAClinicalSupervisors,
  getClinicalSupervisors,
} from "../../redux/State/userSlice";
import { useParams } from "react-router-dom";
import { unwrapResult } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { errorNormalizer } from "../../shared/Helpers/functions";
import { ButtonWrapper } from "../../components/StyledComponents";

const AssignClinicalSupervisor = () => {
  const [open, setOpen] = useState<boolean>(false);
  const user = useSelector((state) => state.user.user);

  return (
    <>
      <CustomButton
        title="Edit Clinical Supervisors"
        onClick={() => setOpen(true)}
        className="marginBottom16"
      />
      <CustomAlert
        open={open}
        onClose={() => setOpen(false)}
        Content={({ onClose }) => <Content onClose={onClose} />}
        title={`Assign Clinical Supervisors to ${user.fullName}`}
      />
    </>
  );
};

const Content = ({ onClose }: { onClose: () => void }) => {
  const dispatch = useDispatch<DispatchProperties>();
  const { userId } = useParams();

  const [supervisorIds, setSupervisorIds] = useState<Array<string>>([]);
  const [pageSize, setPageSize] = useState<number>(8);

  const clinicalSupervisors = useSelector(
    (state) => state.user.clinicalSupervisors
  );

  const clinicalSupervisorsHandler = (event: SelectChangeEvent<string[]>) => {
    const { value } = event.target;

    if (typeof value === "string") return;
    setSupervisorIds(value);
  };

  const saveSupervisorsHandler = () => {
    if (!userId) return;
    dispatch(
      assignClinicalSupervisors({
        userId,
        supervisorIds,
      })
    )
      .then(unwrapResult)
      .then(() => toast("Success"))
      .catch(errorNormalizer)
      .finally(onClose);
  };

  useEffect(() => {
    dispatch(
      getClinicalSupervisors({
        page: "1",
        pageSize: `${pageSize}`,
      })
    );
  }, [pageSize, dispatch]);

  useEffect(() => {
    if (!userId) return;
    dispatch(getBCBAClinicalSupervisors(userId))
      .then(unwrapResult)
      .then((response) => {
        const ids = response.map((x) => x.id);
        setSupervisorIds(ids);
      });
  }, [dispatch, userId]);

  return (
    <>
      <MultipleSelect
        data={
          !!clinicalSupervisors.query
            ? clinicalSupervisors.query.map((x) => ({
                id: x.id,
                name: x.fullName,
              }))
            : []
        }
        setValue={clinicalSupervisorsHandler}
        initialValue={supervisorIds}
        label="Clinical Supervisors"
        className="marginBottom16"
        loadMore={{
          activate: !!clinicalSupervisors.hasNextPage,
          setSize: setPageSize,
        }}
      />
      <ButtonWrapper>
        <CustomButton title="Cancel" onClick={onClose} secondaryButton />
        <CustomButton title="Save" onClick={saveSupervisorsHandler} />
      </ButtonWrapper>
    </>
  );
};

export default AssignClinicalSupervisor;
